// @ts-nocheck
import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useAdminImpersonation } from '@/contexts/AdminImpersonationContext';

/**
 * Hook that returns the effective user data, considering admin impersonation
 * If admin is impersonating, returns impersonated user data
 * Otherwise returns the actual logged-in user data
 *
 * The result keeps one identity while nothing changes, so hooks that depend on
 * it do not re-run on every render of the page above them.
 */
export const useEffectiveAuth = () => {
  const auth = useAuth();
  const { isImpersonating, impersonatedUser, impersonatedProfile } = useAdminImpersonation();

  return useMemo(() => {
    if (isImpersonating && impersonatedUser && impersonatedProfile) {
      return {
        user: impersonatedUser,
        profile: impersonatedProfile,
        session: auth.session, // Keep original session for API calls
        isLoading: auth.isLoading,
        loading: auth.loading,
        signIn: auth.signIn,
        signOut: auth.signOut,
        refreshProfile: auth.refreshProfile,
        setProfile: auth.setProfile,
        isImpersonating: true,
        originalUser: auth.user,
        originalProfile: auth.profile,
      };
    }

    return {
      ...auth,
      isImpersonating: false,
      originalUser: null,
      originalProfile: null,
    };
  }, [auth, isImpersonating, impersonatedUser, impersonatedProfile]);
};
